import React from 'react';
import {Tabs, PageHeader} from 'antd';
import styles from './index.module.less';
import RuleTable from '@/page/admin/InterceptRulePage/RuleTable';
import SensitiveTableHit from '@/page/admin/SensitivePage/SensitiveHitTable';
import {useEditAuthService} from '@/page/admin/adminService';

const {TabPane} = Tabs;

export default function InterceptRulePage() {
    const editable = useEditAuthService(['global:sys_intercept:w']);

    function changeTab(e) {}

    return (
        <PageHeader title="敏感词管理" style={{overflowY: 'auto'}}>
            <Tabs defaultActiveKey="1" onChange={changeTab} className={styles.tabs}>
                <TabPane tab="敏感词规则" key="1">
                    <RuleTable editable={editable} />
                </TabPane>
                <TabPane tab="敏感词触发记录" key="2">
                    <SensitiveTableHit editable={editable} />
                </TabPane>
            </Tabs>
        </PageHeader>
    );
}
